import { Box, Button, Sheet, Stack, Typography } from "@mui/joy";
import { theme } from "styles/theme";
import { previewInputSheetSx } from "./previewStyles";

// 편집/미리보기 탭에서 "참고용"으로만 보여주는 푸터(마치기) 블록.
//
// ── 중요 ──────────────────────────────────────────────────────────────────
// 이 블록들은 순수 UI 표시일 뿐, blocks JSON·데이터 모델·Agent task_patch·저장
// 어디에도 들어가지 않는다. 즉 Agent 는 이 블록의 존재를 모른다. v1 활동지의
// 마지막 카드(LastCard: 소감 입력 + 마치기 안내)를 시각적으로만 모사한다.
//
// 노출 텍스트는 v1 translation (task.activity.common) 의 lastCard1 / "소감
// placeholder" / lastCard2 와 동일.
// 소감 입력 위 안내 문구 (v1 lastCard1) — 미리보기 푸터 블록 1 상단.
export const FOOTER_FEEDBACK_INSTRUCTION =
  "이번 활동은 어땠나요? 느낀 점이나 어려웠던 점, 걱정되는 점을 편하게 말씀해주세요. 없다면 화살표를 눌러 다음으로 넘어가 주세요.";
export const FOOTER_FEEDBACK_PLACEHOLDER = "코치 선생님에게 채팅으로 전달돼요";
export const FOOTER_FINISH_TEXT = "활동을 마쳤어요. [마치기]를 눌러주세요";

// 푸터 블록 1 본문 — v1 LastCard 와 동일하게 안내 문구 + 소감(피드백) 입력칸 +
// 보내기 버튼. v1 FeedbackCell 외형을 정적으로 모사 (입력 불가, 버튼 비동작).
export function FooterFeedbackBlockContent() {
  return (
    <Stack spacing="12px">
      <Typography
        variant="Body"
        sx={{
          color: theme.vars.palette.Content.Strong,
          fontWeight: 500,
          whiteSpace: "pre-wrap",
          wordBreak: "keep-all",
        }}
      >
        {FOOTER_FEEDBACK_INSTRUCTION}
      </Typography>
      <Stack direction="row" spacing={1} sx={{ alignItems: "stretch" }}>
        <Box
          sx={{
            ...previewInputSheetSx,
            flex: 1,
            minWidth: 0,
            display: "flex",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: 1.5,
            color: theme.vars.palette.Content.SuperWeak,
          }}
        >
          {FOOTER_FEEDBACK_PLACEHOLDER}
        </Box>
        {/* 표시 전용 — onClick 없음 + pointerEvents 로 클릭/hover 차단 */}
        <Button
          sx={{
            px: "10px",
            flexShrink: 0,
            alignSelf: "stretch",
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="material-symbols-rounded">send</span>
          </Box>
        </Button>
      </Stack>
    </Stack>
  );
}

// 푸터 블록 2 본문 — 마치기 안내 문구 + 마치기 버튼 (v1 DoneButton 외형).
export function FooterFinishBlockContent() {
  return (
    <Stack spacing="12px">
      <Typography
        variant="Body"
        sx={{
          color: theme.vars.palette.Content.Strong,
          fontWeight: 500,
          whiteSpace: "pre-wrap",
          wordBreak: "keep-all",
        }}
      >
        {FOOTER_FINISH_TEXT}
      </Typography>
      {/* v1 DoneButton 과 동일: 좌측 정렬·내용 너비의 Solid 버튼 (전체 너비
          아님, 기본 md 크기). 표시 전용 — onClick 없음 + pointerEvents 로
          클릭/hover 차단 */}
      <Button
        variant="Solid"
        color="primary"
        size="md"
        sx={{ alignSelf: "flex-start", pointerEvents: "none" }}
      >
        마치기
      </Button>
    </Stack>
  );
}

// 미리보기 탭용 — v1 본문 블록과 동일한 흰 Sheet 로 감싼 2개 푸터 블록.
// (미리보기는 환자 시점 렌더이므로 "푸터 블록 N" 라벨은 붙이지 않는다.)
export function PreviewFooterBlocks() {
  const sheetSx = {
    backgroundColor: "white",
    borderRadius: "12px",
    px: "20px",
    py: "16px",
  } as const;
  return (
    <>
      <Sheet sx={sheetSx}>
        <FooterFeedbackBlockContent />
      </Sheet>
      <Sheet sx={sheetSx}>
        <FooterFinishBlockContent />
      </Sheet>
    </>
  );
}
